import O from "./O";
import CropWrapper from './CropWrapper';
import usePresentSelector from './usePresentSelector';
import G from './Getters';
import { useContext, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { CropAdjustmentContext, FigureChannelAdjustmentContext } from './Contexts';



const DEFAULT_STATE = {
  enteredAdjustmentBar:false
}

const defaultLineColor = ''

const stopProp = e => e.stopPropagation();

export default function CropGridValue({
  tableOutlineShowing,
  width,
  gridCellId,
  value,
  figurePanelId,
  cellLocation,
  editable,
  annotationId,
  inlineCrop,
}){

  const cropAdjustmentContext = useContext(
    CropAdjustmentContext
  );


  const { adjustment, filterId } = useContext(FigureChannelAdjustmentContext);


  let { cropResizeInfo, setCropResizeInfo } = cropAdjustmentContext||{};
  console.log(annotationId,"CropResizeInfo",cropResizeInfo);

  //console.log(inlineCrop);

  //console.log(cropResizeInfo);
  

  let dispatch = useDispatch();


  
  
  let {annotation} = usePresentSelector(state => {
    return {
      annotation:G.getData(state,{itemType:'annotation',_id:annotationId}),
    }
  },[annotationId]);

  let currentCrop = inlineCrop;
  let { imageId } = currentCrop;

  let idWithDescriptionFollowedByDashesToSeparateDescriptionAndEachCellLocationCoordinatesAsUsedByTheOnClickCellSelectionFramework = 'grid_image-'+cellLocation[0]+"-"+cellLocation[1]



  ////console.log("CROP CELL WIDTH: " + width);

  let outerDivHeight = (width/currentCrop.width)*currentCrop.height;


  //currentCrop = currentCrop.x + currentCrop.w / 2;


 
  let temporaryAdjustments = adjustment || {}

  console.log("CropGridValue",filterId);

  return (
    <>
      <div 
        objectType={"CropGridValue"}
        cell={cellLocation?.join('-')}
        valuetype={"crop"}
        imageId={imageId}
        class={"crop-grid-value-container"}
        style={{
          zIndex:cropResizeInfo?1000:'unset',
          height:outerDivHeight,
        }}>
        {false && <O>{currentCrop}</O>}
        <CropWrapper
          //forceSingleChannel={true}
          filterId={filterId}
          canClickToRetryDownload={true}
          key={gridCellId+'_'+annotationId}
          htmlImageClipDivId={idWithDescriptionFollowedByDashesToSeparateDescriptionAndEachCellLocationCoordinatesAsUsedByTheOnClickCellSelectionFramework}
          inlineCrop={currentCrop}
          annotationId={annotationId} 
          imageId={imageId}
          width={width} 
          pxHeight={outerDivHeight}
          gridCellId={gridCellId}
    temporaryAdjustments={temporaryAdjustments.default}
        />

        <div style={{background:'rgb(200,200,200,0.5)'}} class="absolute-cover visible-on-sibling-hover"/>

        

    

      </div>

      
      
    </>
  )


}
